define("settings/components/meta-ad-accounts-card/assignments-modal/row/index", ["exports", "@ember/component", "@ember/object", "@glimmer/component", "@glimmer/tracking", "later/utils/meta-ad-account-status", "@ember/template-factory"], function (_exports, _component, _object, _component2, _tracking, _metaAdAccountStatus, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@glimmer/component",0,"@glimmer/tracking",0,"later/utils/meta-ad-account-status",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck }}
  <div
    class="tAC--mmaRow qa--mmaRow
      {{if @isMultiSelected 'tAC--mmaRow--selected'}}
      {{if this.isSavedState 'tAC--mmaRow--saved'}}
      {{if this.isErrorState 'tAC--mmaRow--error'}}"
    data-row-state={{@rowState}}
  >
    <div class="tAC--mmaRow__header">
      <input
        checked={{@isMultiSelected}}
        class="tAC--mmaRow__multiSelectCheckbox qa--mmaRow__multiSelectCheckbox"
        disabled={{this.isReadOnly}}
        type="checkbox"
        {{on "change" @onToggleMultiSelect}}
      />
      <div class="tAC--mmaRow__details">
        <div class="tAC--mmaRow__nameRow">
          <span class="tAC--mmaRow__name qa--mmaRow__name">{{@adAccount.name}}</span>
          {{#if this.statusBadge}}
            <span
              class="tAC--mmaRow__statusBadge tAC--mmaRow__statusBadge--{{this.statusBadge.kind}} qa--mmaRow__statusBadge"
              data-badge-name={{this.statusBadge.name}}
            >
              {{t this.badgeTranslationKey}}
            </span>
          {{/if}}
        </div>
        <div class="tAC--mmaRow__subtitle u--text--sm qa--mmaRow__subtitle">
          {{#if @adAccount.businessPortfolioName}}
            {{t
              "account.meta_marketing_api.assignments_modal.row.subtitle_with_portfolio"
              businessPortfolioName=@adAccount.businessPortfolioName
              uid=@adAccount.uid
            }}
          {{else}}
            {{t "account.meta_marketing_api.assignments_modal.row.subtitle_id_only" uid=@adAccount.uid}}
          {{/if}}
        </div>
      </div>
    </div>
  
    <div class="tAC--mmaRow__actions">
      {{#unless this.isSavedState}}
        <BasicDropdown as |dd|>
          <dd.Trigger class="tAC--mmaRow__dropdownTrigger qa--mmaRow__dropdownTrigger">
            <span
              class="tAC--mmaRow__pill {{if this.hasStagedGroups 'tAC--mmaRow__pill--manage'}} qa--mmaRow__addGroupsBtn"
            >
              {{#if this.hasStagedGroups}}
                {{t "account.meta_marketing_api.assignments_modal.row.manage_access_groups"}}
              {{else}}
                {{t "account.meta_marketing_api.assignments_modal.row.add_to_access_group"}}
              {{/if}}
            </span>
          </dd.Trigger>
          <dd.Content class="tAC--mmaDropdown qa--mmaDropdown">
            <div class="tAC--mmaDropdown__search">
              <input
                aria-label={{t "account.meta_marketing_api.assignments_modal.dropdown.search_placeholder"}}
                class="tAC--mmaDropdown__searchInput qa--mmaDropdown__searchInput"
                placeholder={{t "account.meta_marketing_api.assignments_modal.dropdown.search_placeholder"}}
                type="text"
                value={{this.searchTerm}}
                {{on "input" this.updateSearch}}
              />
            </div>
            <div class="tAC--mmaDropdown__header">
              {{t "account.meta_marketing_api.assignments_modal.dropdown.header"}}
            </div>
            <ul class="tAC--mmaDropdown__list">
              {{#each this.filteredGroupsWithMergeData as |entry|}}
                <li
                  class="tAC--mmaDropdown__item qa--mmaDropdown__item
                    {{if entry.selected 'tAC--mmaDropdown__item--selected'}}
                    {{if entry.mergeTop 'tAC--mmaDropdown__item--merge-top'}}
                    {{if entry.mergeBottom 'tAC--mmaDropdown__item--merge-bottom'}}"
                  data-group-id={{entry.group.id}}
                >
                  <label class="tAC--mmaDropdown__label">
                    <input
                      checked={{entry.selected}}
                      class="tAC--mmaDropdown__checkbox"
                      type="checkbox"
                      {{on "change" (fn this.toggleGroup entry.group.id)}}
                    />
                    <span class="tAC--mmaDropdown__groupName">{{entry.group.name}}</span>
                  </label>
                </li>
              {{/each}}
            </ul>
          </dd.Content>
        </BasicDropdown>
      {{/unless}}
  
      {{#if this.hasStagedGroups}}
        <div class="tAC--mmaRow__chips qa--mmaRow__chips">
          {{#each this.stagedChips as |chip|}}
            <span class="tAC--mmaRow__chip qa--mmaRow__chip">
              {{chip.name}}
            </span>
          {{/each}}
        </div>
      {{/if}}
  
      {{#if this.isSavedState}}
        <span class="tAC--mmaRow__savedLabel qa--mmaRow__savedLabel">
          {{t "account.meta_marketing_api.assignments_modal.row.saved"}}
        </span>
      {{/if}}
    </div>
  
    {{#if this.isErrorState}}
      <div class="tAC--mmaRow__error qa--mmaRow__error">
        {{t "account.meta_marketing_api.assignments_modal.row.error_prefix"}}
        {{@error}}
      </div>
    {{/if}}
  
    {{#if this.statusBadge.hasWarning}}
      <div
        class="tAC--mmaRow__statusWarning tAC--mmaRow__statusWarning--{{this.statusBadge.kind}} qa--mmaRow__statusWarning"
        data-badge-name={{this.statusBadge.name}}
      >
        {{t this.warningTranslationKey}}
      </div>
    {{/if}}
  </div>
  */
  {
    "id": "Em6kb8oo",
    "block": "[[[10,0],[15,0,[29,[\"tAC--mmaRow qa--mmaRow\\n    \",[52,[30,1],\"tAC--mmaRow--selected\"],\"\\n    \",[52,[30,0,[\"isSavedState\"]],\"tAC--mmaRow--saved\"],\"\\n    \",[52,[30,0,[\"isErrorState\"]],\"tAC--mmaRow--error\"]]]],[15,\"data-row-state\",[30,2]],[12],[1,\"\\n  \"],[10,0],[14,0,\"tAC--mmaRow__header\"],[12],[1,\"\\n    \"],[11,\"input\"],[16,\"checked\",[30,1]],[24,0,\"tAC--mmaRow__multiSelectCheckbox qa--mmaRow__multiSelectCheckbox\"],[16,\"disabled\",[30,0,[\"isReadOnly\"]]],[24,4,\"checkbox\"],[4,[38,1],[\"change\",[30,3]],null],[12],[13],[1,\"\\n    \"],[10,0],[14,0,\"tAC--mmaRow__details\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"tAC--mmaRow__nameRow\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"tAC--mmaRow__name qa--mmaRow__name\"],[12],[1,[30,4,[\"name\"]]],[13],[1,\"\\n\"],[41,[30,0,[\"statusBadge\"]],[[[1,\"          \"],[10,1],[15,0,[29,[\"tAC--mmaRow__statusBadge tAC--mmaRow__statusBadge--\",[30,0,[\"statusBadge\",\"kind\"]],\" qa--mmaRow__statusBadge\"]]],[15,\"data-badge-name\",[30,0,[\"statusBadge\",\"name\"]]],[12],[1,\"\\n            \"],[1,[28,[35,2],[[30,0,[\"badgeTranslationKey\"]]],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"tAC--mmaRow__subtitle u--text--sm qa--mmaRow__subtitle\"],[12],[1,\"\\n\"],[41,[30,4,[\"businessPortfolioName\"]],[[[1,\"          \"],[1,[28,[35,2],[\"account.meta_marketing_api.assignments_modal.row.subtitle_with_portfolio\"],[[\"businessPortfolioName\",\"uid\"],[[30,4,[\"businessPortfolioName\"]],[30,4,[\"uid\"]]]]]],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,2],[\"account.meta_marketing_api.assignments_modal.row.subtitle_id_only\"],[[\"uid\"],[[30,4,[\"uid\"]]]]]],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"tAC--mmaRow__actions\"],[12],[1,\"\\n\"],[41,[51,[30,0,[\"isSavedState\"]]],[[[1,\"      \"],[8,[39,4],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,5,[\"Trigger\"]],[[24,0,\"tAC--mmaRow__dropdownTrigger qa--mmaRow__dropdownTrigger\"]],null,[[\"default\"],[[[[1,\"\\n          \"],[10,1],[15,0,[29,[\"tAC--mmaRow__pill \",[52,[30,0,[\"hasStagedGroups\"]],\"tAC--mmaRow__pill--manage\"],\" qa--mmaRow__addGroupsBtn\"]]],[12],[1,\"\\n\"],[41,[30,0,[\"hasStagedGroups\"]],[[[1,\"              \"],[1,[28,[35,2],[\"account.meta_marketing_api.assignments_modal.row.manage_access_groups\"],null]],[1,\"\\n\"]],[]],[[[1,\"              \"],[1,[28,[35,2],[\"account.meta_marketing_api.assignments_modal.row.add_to_access_group\"],null]],[1,\"\\n\"]],[]]],[1,\"          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n        \"],[8,[30,5,[\"Content\"]],[[24,0,\"tAC--mmaDropdown qa--mmaDropdown\"]],null,[[\"default\"],[[[[1,\"\\n          \"],[10,0],[14,0,\"tAC--mmaDropdown__search\"],[12],[1,\"\\n            \"],[11,\"input\"],[16,\"aria-label\",[28,[37,2],[\"account.meta_marketing_api.assignments_modal.dropdown.search_placeholder\"],null]],[24,0,\"tAC--mmaDropdown__searchInput qa--mmaDropdown__searchInput\"],[16,\"placeholder\",[28,[37,2],[\"account.meta_marketing_api.assignments_modal.dropdown.search_placeholder\"],null]],[16,2,[30,0,[\"searchTerm\"]]],[24,4,\"text\"],[4,[38,1],[\"input\",[30,0,[\"updateSearch\"]]],null],[12],[13],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,0],[14,0,\"tAC--mmaDropdown__header\"],[12],[1,\"\\n            \"],[1,[28,[35,2],[\"account.meta_marketing_api.assignments_modal.dropdown.header\"],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"ul\"],[14,0,\"tAC--mmaDropdown__list\"],[12],[1,\"\\n\"],[42,[28,[37,6],[[28,[37,6],[[30,0,[\"filteredGroupsWithMergeData\"]]],null]],null],null,[[[1,\"              \"],[10,\"li\"],[15,0,[29,[\"tAC--mmaDropdown__item qa--mmaDropdown__item\\n                  \",[52,[30,6,[\"selected\"]],\"tAC--mmaDropdown__item--selected\"],\"\\n                  \",[52,[30,6,[\"mergeTop\"]],\"tAC--mmaDropdown__item--merge-top\"],\"\\n                  \",[52,[30,6,[\"mergeBottom\"]],\"tAC--mmaDropdown__item--merge-bottom\"]]]],[15,\"data-group-id\",[30,6,[\"group\",\"id\"]]],[12],[1,\"\\n                \"],[10,\"label\"],[14,0,\"tAC--mmaDropdown__label\"],[12],[1,\"\\n                  \"],[11,\"input\"],[16,\"checked\",[30,6,[\"selected\"]]],[24,0,\"tAC--mmaDropdown__checkbox\"],[24,4,\"checkbox\"],[4,[38,1],[\"change\",[28,[37,7],[[30,0,[\"toggleGroup\"]],[30,6,[\"group\",\"id\"]]],null]],null],[12],[13],[1,\"\\n                  \"],[10,1],[14,0,\"tAC--mmaDropdown__groupName\"],[12],[1,[30,6,[\"group\",\"name\"]]],[13],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n\"]],[6]],null],[1,\"          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"]],[5]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"hasStagedGroups\"]],[[[1,\"      \"],[10,0],[14,0,\"tAC--mmaRow__chips qa--mmaRow__chips\"],[12],[1,\"\\n\"],[42,[28,[37,6],[[28,[37,6],[[30,0,[\"stagedChips\"]]],null]],null],null,[[[1,\"          \"],[10,1],[14,0,\"tAC--mmaRow__chip qa--mmaRow__chip\"],[12],[1,\"\\n            \"],[1,[30,7,[\"name\"]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[7]],null],[1,\"      \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"isSavedState\"]],[[[1,\"      \"],[10,1],[14,0,\"tAC--mmaRow__savedLabel qa--mmaRow__savedLabel\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"account.meta_marketing_api.assignments_modal.row.saved\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"isErrorState\"]],[[[1,\"    \"],[10,0],[14,0,\"tAC--mmaRow__error qa--mmaRow__error\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[\"account.meta_marketing_api.assignments_modal.row.error_prefix\"],null]],[1,\"\\n      \"],[1,[30,8]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"statusBadge\",\"hasWarning\"]],[[[1,\"    \"],[10,0],[15,0,[29,[\"tAC--mmaRow__statusWarning tAC--mmaRow__statusWarning--\",[30,0,[\"statusBadge\",\"kind\"]],\" qa--mmaRow__statusWarning\"]]],[15,\"data-badge-name\",[30,0,[\"statusBadge\",\"name\"]]],[12],[1,\"\\n      \"],[1,[28,[35,2],[[30,0,[\"warningTranslationKey\"]]],null]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13]],[\"@isMultiSelected\",\"@rowState\",\"@onToggleMultiSelect\",\"@adAccount\",\"dd\",\"entry\",\"chip\",\"@error\"],false,[\"if\",\"on\",\"t\",\"unless\",\"basic-dropdown\",\"each\",\"-track-array\",\"fn\"]]",
    "moduleName": "settings/components/meta-ad-accounts-card/assignments-modal/row/index.hbs",
    "isStrictMode": false
  });
  let RowComponent = _exports.default = (_class = class RowComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "searchTerm", _descriptor, this);
      _defineProperty(this, "isGroupSelected", groupId => this.args.stagedGroups.has(groupId));
    }
    get statusBadge() {
      return (0, _metaAdAccountStatus.getStatusBadge)(this.args.adAccount.accountStatusLabel);
    }

    // Translation key for the badge label, derived from the badge name. The
    // template renders `{{t this.badgeTranslationKey}}` only when statusBadge
    // is defined, so we never return undefined here in that context.
    get badgeTranslationKey() {
      return `account.meta_marketing_api.assignments_modal.status_badge.${this.statusBadge?.name ?? ''}`;
    }
    get warningTranslationKey() {
      return `account.meta_marketing_api.assignments_modal.status_warning.${this.statusBadge?.name ?? ''}`;
    }
    get stagedChips() {
      return [...this.args.stagedGroups].map(id => this.args.groupsById.get(id)).filter(g => g !== undefined);
    }
    get hasStagedGroups() {
      return this.args.stagedGroups.size > 0;
    }
    get isReadOnly() {
      return this.args.rowState === 'saved';
    }
    get isErrorState() {
      return this.args.rowState === 'error';
    }
    get isSavedState() {
      return this.args.rowState === 'saved';
    }
    get filteredGroups() {
      const term = this.searchTerm.trim().toLowerCase();
      if (!term) return this.args.groups;
      return this.args.groups.filter(g => g.name.toLowerCase().includes(term));
    }

    // Per-row dropdown entries with adjacency metadata so the template can apply
    // merge-top / merge-bottom classes without relying on the CSS :has() selector.
    get filteredGroupsWithMergeData() {
      const list = this.filteredGroups;
      return list.map((group, i) => {
        const selected = this.isGroupSelected(group.id);
        const prevSelected = i > 0 && this.isGroupSelected(list[i - 1].id);
        const nextSelected = i < list.length - 1 && this.isGroupSelected(list[i + 1].id);
        return {
          group,
          selected,
          mergeTop: selected && prevSelected,
          mergeBottom: selected && nextSelected
        };
      });
    }
    updateSearch(event) {
      this.searchTerm = event.target.value;
    }
    toggleGroup(groupId, event) {
      const adding = event.target.checked;
      this.args.onAddOrRemoveGroup(groupId, adding);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "searchTerm", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _applyDecoratedDescriptor(_class.prototype, "updateSearch", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateSearch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleGroup", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleGroup"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, RowComponent);
});